"use client";

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ReportTable from "./ReportTable";

const dropdownItems = {
  COUNTRY: [
    "SOUTH AFRICA",
    "Botswana",
    "Cameroon",
    "Congo Democratic Republic (DRC)",
    "Cote-divorie",
    "Eswatini (Swaziland)",
    "Ethiopia",
    "Ghana",
    "Kenya",
    "Lesotho",
    "Malawi",
    "Mozambique",
    "Namibia",
    "Nigeria",
    "Rwanda",
    "Senegal",
    "Sierra Leone",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Tanzania",
    "Uganda",
    "Zambia",
    "Zimbabwe",
  ],
  REGION: [
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",


    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
  ],
  PROJECT: [
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
  ],

  CROP: [
    "MAIZE",
    "Apples",
    "Avocado",
    "Bananas",
    "Beans",
    "Cabbages",
    "Kale",
    "Mangoes",
    "Onions",
    "Passion Fruits",
    "Papaya",
    "Potatoes",
    "Strawberries",
    "Tomatoes",
    "Watermelon",
  ],
  LIVESTOCK: [
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
  ],
  DATA : [
    "PRODUCTION", "Revenue", "Inventory"],
};

const dropdownIcons = {
  COUNTRY:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744492909/Pin_alt_ioedjs.png",
    REGION:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    CROP:
       "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
       DATA:
       "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    PROJECT:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493133/image_fdtjzb.png",
    LIVESTOCK:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493189/image_34_zwohkn.png",
};
const data = Array(5).fill({
  date: "07/07/2025",
  opening: "20000",
  closing: "20000",
  value: "2000",
});
const renderDropdown = (type) => {
  const customLabels = {
    Seed: "Crop Report",
    Fertizilar: "Fertilizer Report",
    Herbicides: "Herbicides Report",
  };

  return (
    <div className="flex justify-end   md:gap-2 gap-[1px] md:mt-12 w-full sm:w-auto">
 <div>
 {Object.keys(dropdownItems)
        .filter((itemType) => itemType === type)
        .map((itemType) => (
          <Dropdown
            key={itemType}
            label={customLabels[itemType] || itemType}
            items={dropdownItems[itemType]}
            type={itemType}
          />
        ))}
 </div>
    </div>
  );
};
const renderTable = (title, type, dropdownType) => (
<div className="w-full font-sans text-[10px] md:text-[32px]">
  <div className="flex justify-between items-center mb-2 md:mb-1 md:mt-5">
    <div className="flex justify-between">
      {title && (
        <div className={`${title === "INVENTORY" ? "-mb-12" : ""}`}>
          <h2 className="text-[#FFBD26] font-bold text-[8px] md:text-[20px]">
            {title}
          </h2>
        </div>
      )}
      <div className="w-10"></div>
      {dropdownItems[dropdownType] && (
        <Dropdown
          label={
            {
              Seed: "Crop Report",
              Fertilizer: "Fertilizer Report",
              Herbicides: "Herbicides Report",
            }[dropdownType] || dropdownType
          }
          items={dropdownItems[dropdownType]}
          type={dropdownType}
        />
      )}
    </div>
  </div>

  <table className="w-full table-fixed  border-separate border-spacing-y-1 md:-mt-3">
    <thead>
      <tr>
        <th className="text-left font-bold w-auto md:w-[140px] text-[6px] md:text-[20px]">
          {type.toUpperCase()}
        </th>
        <th className="text-left font-normal w-auto md:w-[140px]">
          Opening Stock <strong>(t)</strong>
        </th>
        <th className="text-left font-normal w-auto md:w-[140px]">
          Closing Stock <strong>(t)</strong>
        </th>
        <th className="text-left font-normal w-auto md:w-[140px]">
          Value <strong>(USD)</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      {data.map((row, index) => (
        <tr key={index}>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px]">
            {row.date}
          </td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#E7EBEB]">
            {row.opening}
          </td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#CFD7D7]">
            {row.closing}
          </td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#9FAFAF] text-black">
            {row.value}
          </td>
        </tr>
      ))}
      <tr>
        <td className="h-[5px]"></td>
      </tr>
      <tr className="font-bold">
        <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px]">TOTAL</td>
        <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#E7EBEB]">20000</td>
        <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#CFD7D7]">20000</td>
        <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#9FAFAF] text-black">2000</td>
      </tr>
    </tbody>
  </table>
</div>

);
const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);

  const icon = dropdownIcons[type];

  return (
<div className="flex flex-col w-full relative ">
  {/* Label */}
  <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
    {label}
  </label>

  {/* Button + Icon Container */}
  <div className="flex relative z-20 w-fit">
    {/* Dropdown Button */}
    <button
      onClick={() => setIsOpen((prev) => !prev)}
      className="xl:w-[170px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[40px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-3 rounded-l-[10px]"
    >
      <span className="md:text-[12px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
    </button>

    {/* Icon Box */}
    <div
      className="w-[20px] h-[15px] md:h-[40px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-[10px] -ml-2 z-30 cursor-pointer"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
        alt="expand"
        className="w-3 h-3 md:w-5 md:h-5"
      />
    </div>
  </div>

  {/* Dropdown List */}
  {/* Dropdown List */}
  <AnimatePresence>
    {isOpen && (
      <motion.ul
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
      >
        {items.map((item, index) => (
          <li
            key={index}
            onClick={() => {
              setSelected(item);
              setIsOpen(false);
            }}
            className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
          >
            <img src={icon} className="md:w-4 md:h-4 h-2 w-2 mr-2" alt="icon" />
            <span className="text-black">{item}</span>
          </li>
        ))}
      </motion.ul>
    )}
  </AnimatePresence>

  {/* Hint Text */}


</div>


  
  );
};

const HeatMaps2 = () => {
    const [isOpen, setIsOpen] = useState(false)
  
    const toggleDropdown = () => setIsOpen(!isOpen)
  
  return (
    <div className="mb-10 md:mt-2 md:pt-0 pt-4 font-Inter w-full  px-6 md:px-[6%]  mx-auto">
  
      <div className="flex justify-between items-center md:mb-5 mb-5">
        <h2 className="text-[14px] md:text-[36px] font-bold text-[#FDBD26] ">
        DASHBOARDS
          </h2>
          <div className="flex flex-row md:space-y-0 md:space-x-40 text-[#19253C] md:mt-10 mt-2 ">
          <div className="flex md:space-x-4 space-x-1 items-center">
            <h1 className="italic md:text-[20px]  text-[8px] font-normal">Opening Date</h1>
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745016720/image_1686_xak1hv.png" alt="calendar" className="md:w-[49px] md:h-[51px]  h-[15px]" />
          </div>
          <div className="flex md:space-x-4 space-x-1 items-center">
            <h1 className="italic md:text-[20px]  text-[8px] 1font-normal">Closing Date</h1>
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745016720/image_1686_xak1hv.png" alt="calendar" className="md:w-[49px] md:h-[51px] h-[15px]" />
          </div>
        </div>
        </div>
      <div className="flex md:gap-2 gap-[1px]   ">
    

        {Object.keys(dropdownItems).map((type) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };

          const displayLabel = customLabels[type] || type;

          return (
            <div key={type} className="w-full sm:w-auto">
              <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
            </div>
          );
        })}
      </div>
  <div className="md:mt-6 mt-4">
 <div className="flex justify-between items-center md:mb-4"> 
         <h2 className="md:text-[32px] text-[14px] font-semibold mb-2">HEAT MAPS</h2>

 </div>

        {/* ADMINISTRATIVE Section */}
        <div className="mb-6">
          {/* Flex container with label and grid in one row */}
          <div className="flex md:flex-row items-start gap-1 md:gap-28">
            {/* ADMINISTRATIVE label on the left */}
            <div className=" w-[90px] md:w-[200px]">
              <p className="text-[#FFBD26] font-semibold text-[10px] md:text-[20px]">ADMINISTRATIVE</p>
            </div>

            {/* Grid Header on the right */}
            <div className="grid grid-cols-9 md:grid-cols-9 md:gap-[10px] gap-[20px] flex-1">
              {[
                'KWAZULU NATAL', 'LIMPOPO', 'MPUMALA NGA', 'GAUTENG', 'FREESTATE',
                'WESTERN CAPE', 'EASTERN CAPE', 'NOTHERN CAPE', 'NORTH WEST'
              ].map((region, i) => (
                <div key={i} className="text-[4px] md:text-[16px] text-black font-extrabold px-1 text-center">
                  {region}
                </div>
              ))}
            </div>
          </div>

          {/* Section Title - PROJECTS */}
          <div className="mt-2">
            <p className="text-[#FFBD26] font-semibold mb-2 text-[10px] md:text-[20px]">ENTERPRISE</p>
            <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

            {/* Make full grid scrollable horizontally on mobile */}
            <div className="overflow-x-auto">
              <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)]  gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3 ">
                {['Commercial farmers', 'Small Holder farmers', 'Small Holder farmers', 'Emerging farmers'].map((label, i) => (
                  <React.Fragment key={i}>
                    <div className={`text-[6px] md:text-[20px] text-black ${i === 1 || i === 2 ? 'mb-2 md:mb-5' : ''}`}>
                      {label}
                    </div>
                    {[...Array(9)].map((_, j) => (
                      <div
                        key={j}
                        className={`h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${i === 1 || i === 2 ? 'mb-2 md:mb-4' : ''
                          }`}
                      >
                        {(i === 2 || i === 3) ? '-' : '345'}
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>





        {/* PROJECTS Section */}
        {/* PROJECTS Section */}
        <div className="mb-3 ">
          <p className="font-semibold text-[10px] md:text-[20px] text-[#FFBD26] mb-1">PROJECTS</p>
          <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)]  gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {['No of sites', 'Beneficiaries / site',].map((label, i) => (
              <React.Fragment key={i}>
                <div className={`md:text-[20px] text-[6px] text-black ${i === 1 || i === 2 ? 'mb-5' : ''}`}>{label}</div>
                {[...Array(9)].map((_, j) => (
                  <div
                    key={j}
                    className={`h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${i === 1 || i === 2 ? 'mb-4' : ''
                      }`}
                  >
                    {(i === 2 || i === 3) ? '-' : '345'}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="items-center gap-8 flex-wrap">
          {/* Sites */}
          <div className="flex items-center gap-4 mb-1">
            <div className="font-bold md:text-[16px] text-[8px] whitespace-nowrap w-[80px] md:w-[290px]">
              Sites: <span className="text-[#CFD7D7]">522</span>
            </div>
            <div className="w-[199px] md:h-[26px] h-5 bg-[#CFD7D7] flex items-center justify-center rounded-md">
              <span className="text-black md:text-xl text-[8px]  font-semibold">120</span>
            </div>
          </div>

          {/* Beneficiaries */}
          <div className="flex items-center gap-4 mb-1">
            <div className="font-bold md:text-[16px] text-[8px] whitespace-nowrap w-[80px] md:w-[290px]">
              Beneficiaries: <span className="text-[#CFD7D7]">Total</span>
            </div>
            <div className="w-[199px] md:h-[26px]  h-5 bg-[#CFD7D7] flex items-center justify-center rounded-md">
              <span className="text-black md:text-xl text-[8px] font-semibold">270</span>
            </div>
          </div>

          {/* Total Country */}
          <div className="flex items-center gap-4 mb-1">
            <div className="font-bold md:text-[16px] text-[8px]  whitespace-nowrap w-[80px] md:w-[290px]">Total country:</div>
            <div className="w-[199px] md:h-[26px]  h-5 bg-[#CFD7D7] flex items-center justify-center rounded-md">
              <span className="text-black md:text-xl text-[8px]  font-semibold">15600</span>
            </div>
          </div>
        </div>


        {/* MARKET ASSURANCE Section */}
        <div className="mt-2">
          <p className="text-[#FFBD26] font-semibold mb-2 text-[10px] md:text-[20px]">MARKET ASSURANCE</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'Abattoirs Total', value: '1' },
              { label: 'Active Abattoirs', value: '2' },
              { label: 'Farmers per Abattoir', value: '3000' },
              { label: 'Production', value: '3,900,000' }
            ].map((item, i) => (
              <React.Fragment key={i}>
                <div className={`md:text-[20px] text-[6px] text-black `}>
                  {item.label}
                </div>
                {[...Array(9)].map((_, j) => (
                  <div
                    key={j}
                    className={`md:h-7 h-4 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center `}
                  >
                    {item.value}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>


        {/* DEMOGRAPHICS Section */}
        <div className="mb-3 mt-3">
          <p className="font-semibold md:text-[20px] text-[10px] text-[#FFBD26] mb-1">DEMOGRAPHICS</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {['%Households in farming', '%Households in farming',].map((label, i) => (
              <React.Fragment key={i}>
                <div className={`md:text-[20px] text-[6px] text-black ${i === 1 || i === 2 ? 'mb-5' : ''}`}>{label}</div>
                {[...Array(9)].map((_, j) => (
                  <div
                    key={j}
                    className={`md:h-7 h-4 bg-[#CFD7D7] rounded-md  text-[5px] md:text-[16px] flex items-center justify-center ${i === 1 || i === 2 ? 'mb-4' : ''
                      }`}
                  >
                    16%
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="items-center gap-8 flex-wrap">


          {/* Total Country */}
          <div className="flex items-center gap-4 mb-1">
            <div className="font-bold text-[6px] md:text-[20px] whitespace-nowrap w-[80px] md:w-[290px]">Total country:</div>
            <div className="md:w-[199px] md:h-[26px] h-4 w-[100px] bg-[#CFD7D7] flex items-center justify-center rounded-md">
              <span className="text-black  text-[8px] md:text-xl font-bold">16%</span>
            </div>
          </div>
        </div>

        {/* ENTREPRENEURSHIP Section */}
        <div className="mb-3 mt-6">
          <p className="font-semibold text-[10px] md:text-[20px] text-[#FFBD26] mb-1">ENTERPRENEURSHIP</p>
          <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)]  grid-cols-[90px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 md:mt-3 mt-1">
            {['Enterprises',].map((label, i) => (
              <React.Fragment key={i}>
                <div className={`md:text-[20px] text-[6px] text-black ${i === 1 || i === 2 ? 'mb-5' : ''}`}>{label}</div>
                {[...Array(9)].map((_, j) => (
                  <div
                    key={j}
                    className={`md:h-7 h-4 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${i === 1 || i === 2 ? 'mb-4' : ''
                      }`}
                  >
                    12,000
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="mb-3 md:mt-6 mt-3">
          <p className="font-semibold md:text-[20px] text-[10px] text-[#FFBD26] mb-1">EMPLOYMENT</p>
          <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)]  grid-cols-[90px_repeat(9,1fr)] gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            <li className="md:text-[20px] text-[8px] text-[#FF1F1F] list-disc">Unemployment rate</li>

            {[
              '28.6%', '36.6%', '31.9%', '34.7%', '37.9%', '19.6%', '36.6%', '27.4%', '41.3%'
            ].map((value, j) => {
              const isRedBox = [1, 4, 6, 8, 9].includes(j + 1); // Boxes with red text on light bg
              const isWhiteOnRed = [2, 5, 7].includes(j + 1);   // Boxes with white text on red bg

              return (
                <div
                  key={j}
                  className={`
            md:h-7 h-4 rounded-md text-[6px] md:text-[16px] flex items-center justify-center
            ${isWhiteOnRed ? 'bg-[#FF1F1F] text-white' : 'bg-[#CFD7D7] text-[#FF1F1F]'}
          `}
                >
                  {value}
                </div>
              );
            })}
          </div>
        </div>


        <p className="md:text-[24px] text-[10px] text-[#FFBD26] md:mt-12 mt-5">
          <span className="font-bold text-black">Goal:</span> Country Value chain stakeholders gain visibility of entire farming life cycle
        </p>
    <ReportTable/>
      </div>
    </div>
  );
};

export default HeatMaps2;
